/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './Description.css'

import elcarProduct from 'assets/img/mockups/elcar-icon.png';
import elcarProduct2 from 'assets/img/mockups/iPad ELCAR.png';


// reactstrap components
import {
  Badge,
  Container,
  Row,
  Col,

} from "reactstrap";

class Description extends React.Component {

  render() {
    return (
      <>
        <section className="section section-lg product-description-elcar">
          <Container>
            <Row className="row-grid align-items-center">
              <Col className="order-md-1 elcar-product-1" md="6">
                <div className="blob"></div>
                <img
                  alt="..."
                  className="img-fluid product-img-1 "
                  src={elcarProduct}
                />

              </Col>
              <Col className="order-md-2" md="6">
                <div className="pr-md-5">

                  <h2>What is ELCAR?</h2>
                  <p>
                    The ELCAR is the newly updated and enhanced version of the C-PIRK and VBDA,
                    offering streamlined assessments, updated repertoires, and evidence-based strategies
                    for promoting verbal behavior development in learners of all ages.
                  </p>
                  <ul className="list-unstyled mt-5 ">
                    <li className="py-2">
                      <div className="d-flex align-items-center align-top-bullet">
                        <div>
                          <Badge
                            className="badge-circle mr-3"
                            color="primary"
                          >
                            <i className="ni ni-check-bold" />
                          </Badge>
                        </div>
                        The new ELCAR APP emcompasses the Material Packet and Record Book
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center align-top-bullet">
                        <div>
                          <Badge
                            className="badge-circle mr-3"
                            color="primary"
                          >
                            <i className="ni ni-check-bold" />
                          </Badge>
                        </div>
                        ELCAR facilitates a systematic and effective approach to verbal behavior intervention,
                        ultimately leading to improved communication outcomes for learners.
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center align-top-bullet">
                        <div>
                          <Badge
                            className="badge-circle mr-3"
                            color="primary"
                          >
                            <i className="ni ni-check-bold" />
                          </Badge>
                        </div>
                        <div>
                          By systematically assessing a learner's strengths and weaknesses
                          across various verbal behavior domains, the ELCAR empowers educators and therapists.
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>


            </Row>


            <Row className="row-grid align-items-center">

              <Col className="order-md-1" md="6">
                <div className="pr-md-5">

                  <h2>How does it work?</h2>
                  <p>
                  ELCAR (Early Learning Child Assessment and Repertory) is a comprehensive tool designed to evaluate a 
                  child's skills and repertories across various developmental domains. It's essentially a structured 
                  assessment framework that uses a detailed checklist to determine if a child exhibits specific skills 
                  or behaviors.  ELCAR is typically applied at least once a year for each child to track their 
                  developmental progress.
                  <br/>
                  <br/>
                  ELCAR is structured around three main components, or "books": the Manual, the Materials Packet, and 
                  the Inventory Record Book. Each plays a critical role in the assessment process.
                  </p>

                </div>
              </Col>



              <Col className="order-md-2 elcar-product-2" md="6">
                <div className="blob-2"></div>
                <img
                  alt="..."
                  className="img-fluid product-img-2"
                  src={elcarProduct2}
                />



              </Col>
            </Row>

          </Container>
        </section>

      </>
    )
  }
}

export default Description;